import './index.css'
import cn from 'clsx'
import React from 'react'
type Props = {
  size: 'small' | 'medium' | 'large'
}

/**
 * Loading indicator component with spinning animation and configurable sizes
 * Displays a circular spinner SVG with size variants for different contexts
 * @param size - Size variant: 'small', 'medium', or 'large'
 */
const LoadingIndicator = ({ size = 'medium' }: Props) => {
  return (
    <div
      className={cn('LoadingIndicator', {
        'LoadingIndicator--small': size === 'small',
        'LoadingIndicator--medium': size === 'medium',
        'LoadingIndicator--large': size === 'large',
      })}
    >
      <svg className="LoadingIndicator-icon" viewBox="0 0 20 20">
        <path d="M7.229 1.173a9.25 9.25 0 1011.655 11.412 1.25 1.25 0 10-2.4-.698 6.75 6.75 0 11-8.506-8.329 1.25 1.25 0 10-.75-2.385z" />
      </svg>
    </div>
  )
}

export default React.memo<Props>(LoadingIndicator)
